export default __webpack_public_path__ + "static/B0225-35d2039a6bcc8af87d0245618709c768.png";